import { useState } from "react";
import { ArrowUpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";

export const DELIVERY = [["da_contattare", "Da contattare", "bg-slate-100 text-slate-700 border-slate-300"], ["contattato", "Contattato", "bg-sky-100 text-sky-800 border-sky-300"], ["accettato", "Accettato", "bg-emerald-100 text-emerald-800 border-emerald-300"], ["rinunciato", "Rinunciato", "bg-amber-100 text-amber-800 border-amber-300"], ["irreperibile", "Irreperibile", "bg-red-100 text-red-800 border-red-300"]];
export const deliveryLabel = (s) => (DELIVERY.find((d) => d[0] === s) || DELIVERY[0])[1];
export const deliveryClass = (s) => (DELIVERY.find((d) => d[0] === s) || DELIVERY[0])[2];

export function DeliveryControls({ draw, w, reservesLeft, onChanged }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const status = w.delivery?.status || "da_contattare";
  const set = async (s) => {
    setBusy(true);
    try { await api.finalDrawDelivery(draw.id, w.pid, s, note); toast.success(`Stato aggiornato: ${deliveryLabel(s)}`); setNote(""); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "Aggiornamento non riuscito"); } finally { setBusy(false); }
  };
  const promote = async () => {
    if (!window.confirm("Promuovere la prima riserva disponibile a vincitore di questo premio? La riserva verrà avvisata.")) return;
    setBusy(true);
    try { const r = await api.finalDrawPromote(draw.id, w.pid); toast.success(`Riserva ${r.winner.pid} promossa${r.notified ? " e avvisata" : ""}`); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "Promozione non riuscita"); } finally { setBusy(false); }
  };
  return (
    <div className="ml-7 mb-2 flex flex-wrap items-center gap-1.5" data-testid={`delivery-${w.pid}`}>
      {DELIVERY.map(([s, l, cls]) => (
        <button key={s} type="button" disabled={busy} onClick={() => set(s)} data-testid={`delivery-${w.pid}-${s}`} className={`rounded-full border px-2 py-0.5 text-[11px] transition-opacity ${status === s ? cls + " font-semibold" : "border-border text-muted-foreground hover:text-foreground"}`}>{l}</button>
      ))}
      <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="nota (facoltativa)" className="h-7 text-[11px] w-44" data-testid={`delivery-note-${w.pid}`} />
      {(status === "rinunciato" || status === "irreperibile") && reservesLeft > 0 && (
        <Button size="sm" variant="outline" className="h-7 text-[11px] gap-1 border-amber-400 text-amber-800" disabled={busy} onClick={promote} data-testid={`delivery-promote-${w.pid}`}><ArrowUpCircle className="h-3.5 w-3.5" /> Promuovi riserva</Button>
      )}
      {w.delivery?.note && <span className="text-[11px] text-muted-foreground">· {w.delivery.note}</span>}
    </div>
  );
}
